"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var react_socks_1 = __importDefault(require("react-socks"));

var shared_1 = require("../../../shared");

var Table_meta_1 = require("./Table.meta");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var DisclaimersWrapper_1 = __importDefault(require("./styledComponents/DisclaimersWrapper"));

var Body_1 = __importDefault(require("./components/Body"));

var Head_1 = __importDefault(require("./components/Head"));

var Table_1 = __importDefault(require("./styledComponents/Table"));

var Card_1 = __importDefault(require("./styledComponents/Card"));

var ListGroup_1 = __importDefault(require("./styledComponents/ListGroup"));

var ListGroupTitle_1 = __importDefault(require("./styledComponents/ListGroupTitle"));

var ListGroupSubTitle_1 = __importDefault(require("./styledComponents/ListGroupSubTitle"));

var Caption_1 = __importDefault(require("./styledComponents/Caption"));

var mobx_1 = require("mobx");

var Translate_1 = __importDefault(require("../Translate"));

var Translate_2 = require("../Translate/Translate");

var Disclaimers_1 = __importDefault(require("../../overview/Disclaimers/Disclaimers"));

var List_1 = __importDefault(require("../List"));

var TableLogic_1 = require("./TableLogic");

var Tooltip_1 = __importDefault(require("../Tooltip"));

var AccordionPanel_1 = __importDefault(require("../AccordionPanel/AccordionPanel"));

var CellValue_1 = __importDefault(require("./components/CellValue"));

var models_1 = require("../SortButton/models");

var Table =
/** @class */
function (_super) {
  __extends(Table, _super);

  function Table(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Table_meta_1.TABLE_CATEGORY_KEY;
    _this.componentKey = Table_meta_1.TABLE_COMPONENT_KEY;
    _this.sortingDirections = {};

    _this.wrapSort = function (onChangeFn) {
      var response = function response(payload, direction) {
        return __awaiter(_this, void 0, void 0, function () {
          var _this = this;

          return __generator(this, function (_a) {
            if (this.sort.mode === 'single') {
              Object.keys(this.sortingDirections).forEach(function (key) {
                _this.sortingDirections[key] = {
                  direction: models_1.SortButtonDirection.unset
                };
              });
              this.sortingDirections[payload.id] = {
                direction: direction
              };
              this.sortingDirections = __assign({}, this.sortingDirections);
            }

            if (onChangeFn) {
              onChangeFn(payload, direction);
            }

            return [2
            /*return*/
            ];
          });
        });
      };

      return response;
    };

    _this.loadGrouping = function (props) {
      var grouping = _this.props.grouping;
      _this.grouping = _this.orchestrateGrouping(props, grouping);
    };

    _this.orchestrateGrouping = function (props, grouping) {
      var response;

      if (grouping) {
        response = __assign({}, grouping);

        if (!response.id) {
          response.id = ksys_app_template_1.utils.guid.generateGuid();
        }

        var columnOverrides = response.columnOverrides;

        if (!response.columns && columnOverrides) {
          var columns = [];

          for (var columnIndex = 0; columnIndex < _this.columns.length; columnIndex++) {
            var column = _this.columns[columnIndex];
            var columnOverride = columnOverrides[column.id];

            if (columnOverride) {
              columns.push(ksys_app_template_1.utils.object.deepMergeObjects(column, columnOverride));
            }
          }

          response.columns = columns;
        } // load the last grouping to handle the final columns having an expanded column


        if (!response.childGroup && response.getRowsQuery) {
          response.childGroup = {
            id: '_lastGroup'
          };
        }

        if (response.childGroup) {
          response.childGroup = _this.orchestrateGrouping(props, response.childGroup);
        }

        if (!response.columns) {
          response.columns = __spreadArrays(props.columns || []);
        }

        if (!response.columns.some(function (column) {
          return column.id === '_expander';
        })) {
          response.columns.unshift(_this.logic.getExpanderColumn(!!response.childGroup));
        }
      }

      return response;
    };

    _this.loadRows = function (props) {
      var _a = props.rows,
          rows = _a === void 0 ? [] : _a;
      _this.rows = rows.map(function (row, rowIndex) {
        var response = __assign({}, row);

        if (!response._rowKey) {
          response._rowKey = ksys_app_template_1.utils.guid.generateGuid();
        }

        return response;
      });
    };

    _this.rows = [];

    _this.getConditionalClassName = function (responseContext, conditionalClassNames, baseClassName) {
      var queryStore = _this.props.queryStore;
      var classNames = [];

      if (baseClassName) {
        classNames.push(baseClassName);
      }

      if (conditionalClassNames) {
        for (var _i = 0, conditionalClassNames_1 = conditionalClassNames; _i < conditionalClassNames_1.length; _i++) {
          var conditionalClassName = conditionalClassNames_1[_i];
          var className = conditionalClassName.className,
              classNameQueryOptions = conditionalClassName.classNameQuery,
              conditional = conditionalClassName.conditional;
          var mustAddClassName = false;

          if (conditional) {
            if (queryStore) {
              var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional);
              mustAddClassName = conditionalHelper.matchesWithOptions({
                executionOptions: __assign(__assign({}, queryStore.executionOptions), {
                  responseContext: responseContext
                })
              });
            }
          } else {
            mustAddClassName = true;
          }

          if (mustAddClassName) {
            if (className) {
              classNames.push(className);
            } else if (classNameQueryOptions) {
              if (queryStore) {
                var queryResponse = queryStore.query(classNameQueryOptions, {
                  responseContext: responseContext
                });

                if (typeof queryResponse === 'string') {
                  classNames.push(queryResponse);
                }
              }
            }
          }
        }
      }

      return classNames.join(' ');
    };

    _this.renderCards = function () {
      var response = _this.rows.map(function (row, rowIndex) {
        var events = _this.getEvents(_this.events && _this.events['card'], row, rowIndex);

        return react_1.default.createElement(Card_1.default, __assign({
          key: rowIndex
        }, events), _this.renderListForRow(row));
      });

      return response;
    };

    _this.renderAccordion = function () {
      var headingKey = 'name';

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(_this.columns)) {
        headingKey = _this.columns[0].key;
      }

      var response = _this.rows.map(function (row, rowIndex) {
        var key = "panel_" + rowIndex;
        var heading = row[headingKey];

        var isOpen = _this.isPanelOpen(heading, rowIndex);

        return react_1.default.createElement(AccordionPanel_1.default, {
          key: key,
          panelKey: key,
          heading: heading,
          isOpen: isOpen
        }, _this.renderListForRow(row, false));
      });

      return response;
    };

    _this.renderListForRow = function (row, includeHeader) {
      if (includeHeader === void 0) {
        includeHeader = true;
      }

      var _a = _this.props,
          _b = _a.cardListProps,
          cardListProps = _b === void 0 ? {} : _b,
          displayResponsiveGroups = _a.displayResponsiveGroups,
          _c = _a.headerGroups,
          headerGroups = _c === void 0 ? [] : _c;

      var slicedColumns = _this.columns.slice(includeHeader ? 0 : 1);

      var lastHeaderGroup = headerGroups[0];
      var items = slicedColumns.reduce(function (listItems, column) {
        var headerGroup = headerGroups.find(function (group) {
          return group.id === column.headerGroupId;
        });

        var columnHeaderTooltip = _this.getTooltipHeaderProps(column, {
          target: 'header'
        });

        var columnValueTooltip = _this.getTooltipRowProps(row, column);

        if (displayResponsiveGroups && headerGroup && headerGroup !== lastHeaderGroup) {
          var groupHeaderTooltip = _this.getTooltipHeaderProps(headerGroup, {
            target: 'header'
          });

          var groupHeaderSubTitleTooltip = _this.getTooltipHeaderProps(headerGroup, {
            target: 'subtitle'
          });

          var groupLabel = react_1.default.createElement(ListGroup_1.default, null, react_1.default.createElement(ListGroupTitle_1.default, null, react_1.default.createElement(Translate_1.default, null, headerGroup.header), groupHeaderTooltip && _this.getTooltip(groupHeaderTooltip), ' ', react_1.default.createElement(ListGroupSubTitle_1.default, null, react_1.default.createElement(Translate_1.default, null, headerGroup.subTitle), groupHeaderSubTitleTooltip && _this.getTooltip(groupHeaderSubTitleTooltip))));
          listItems.push([groupLabel]);
          lastHeaderGroup = headerGroup;
        }

        var labelText = column.header;
        var label = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Translate_1.default, null, column.header), columnHeaderTooltip && _this.getTooltip(columnHeaderTooltip));

        var valueText = _this.logic.getValue(row, column);

        var value = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(CellValue_1.default, {
          table: _this,
          cellValue: valueText,
          column: column
        }), columnValueTooltip && _this.getTooltip(columnValueTooltip));
        var item = [label, value].filter(function (field) {
          return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(field);
        });

        if (item && item.length > 0 && (!ksys_app_template_1.utils.typeChecks.isNullOrWhitespace(labelText) || column.contextMenuProps || column.checkboxProps || !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(valueText) && (typeof valueText !== 'string' || !ksys_app_template_1.utils.typeChecks.isNullOrWhitespace(valueText)))) {
          listItems.push(item);
        }

        return listItems;
      }, []);
      var listProps = ksys_app_template_1.utils.object.deepMergeObjects(cardListProps, {
        items: items
      });
      return react_1.default.createElement(List_1.default, __assign({}, listProps));
    };

    _this.renderTable = function () {
      var _a = _this.props,
          className = _a.className,
          columns = _a.columns,
          rows = _a.rows,
          disclaimersProps = _a.disclaimersProps,
          responsiveMode = _a.responsiveMode,
          cardListProps = _a.cardListProps,
          formatsByType = _a.formatsByType,
          excludeEmptyColumns = _a.excludeEmptyColumns,
          describedby = _a.describedby,
          caption = _a.caption,
          otherProps = __rest(_a, ["className", "columns", "rows", "disclaimersProps", "responsiveMode", "cardListProps", "formatsByType", "excludeEmptyColumns", "describedby", "caption"]);

      var events = _this.getEvents(_this.events.table);

      return react_1.default.createElement(Table_1.default, __assign({
        "aria-describedby": describedby
      }, events || {}, otherProps), react_1.default.createElement(Caption_1.default, null, react_1.default.createElement(Translate_1.default, null, caption)), react_1.default.createElement(Head_1.default, {
        table: _this,
        headerRows: _this.logic.headerMapping
      }), react_1.default.createElement(Body_1.default, {
        table: _this,
        rows: _this.rows
      }));
    };

    _this.getDisclaimersProps = function () {
      var _a;

      var explicitDisclaimersProps = _this.props.disclaimersProps;
      var response = JSON.parse(JSON.stringify(explicitDisclaimersProps || {}));
      var globalDisclaimersStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();

      if (globalDisclaimersStore) {
        var appKey = _this.props.configuration && _this.props.configuration.appKey;

        if (appKey) {
          var globalDisclaimersForApp = globalDisclaimersStore.get(ksys_app_template_1.models.disclaimers.GlobalDisclaimerLevel.app, appKey);

          if (globalDisclaimersForApp && globalDisclaimersForApp.length > 0) {
            if (!response.disclaimers) {
              response.disclaimers = [];
            }

            (_a = response.disclaimers).push.apply(_a, globalDisclaimersForApp.map(function (globalDisclaimerForApp) {
              var p = {
                text: globalDisclaimerForApp.text,
                superscript: typeof globalDisclaimerForApp.superscript === 'number' ? globalDisclaimerForApp.superscript.toString() : undefined
              };
              return p;
            }));
          }
        }
      }

      return response;
    };

    _this.loadGrouping(props);

    _this.loadRows(props);

    return _this;
  }

  Object.defineProperty(Table.prototype, "sort", {
    get: function get() {
      var defaultSort = {
        mode: 'multiple'
      };
      return __assign(__assign({}, defaultSort), this.props.sort || {});
    },
    enumerable: true,
    configurable: true
  });

  Table.prototype.componentDidUpdate = function (prevProps) {
    if (JSON.stringify(prevProps.grouping || {}) !== JSON.stringify(this.props.grouping || {}) || JSON.stringify(prevProps.columns || []) !== JSON.stringify(this.props.columns || []) && this.props.grouping) {
      this.loadGrouping(this.props);
      this.forceUpdate();
    }

    if (JSON.stringify(prevProps.rows || []) !== JSON.stringify(this.props.rows || [])) {
      this.loadRows(this.props);
      this.forceUpdate();
    }
  };

  Object.defineProperty(Table.prototype, "hasGrouping", {
    get: function get() {
      return !!this.grouping;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Table.prototype, "logic", {
    get: function get() {
      return new TableLogic_1.TableLogic(this.props, this.globalConfiguration);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Table.prototype, "emptyColumnIds", {
    get: function get() {
      return this.logic.emptyColumnIds;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Table.prototype, "columns", {
    get: function get() {
      return this.logic.visibleColumns;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Table.prototype, "headerColumns", {
    get: function get() {
      return this.logic.headerColumns;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Table.prototype, "events", {
    get: function get() {
      return this.props.events || {};
    },
    enumerable: true,
    configurable: true
  });

  Table.prototype.getTooltipHeaderProps = function (column, matchingProperties) {
    var queryStore = this.props.queryStore;
    var response;

    if (column && Array.isArray(column.tooltips) && column.tooltips.length > 0) {
      var tooltips = ksys_app_template_1.utils.collection.filterWithMatchingProperties(column.tooltips, matchingProperties);

      if (tooltips) {
        for (var i = 0; i < tooltips.length; i++) {
          var tooltip = tooltips[i];

          if (tooltip && tooltip.conditional && tooltip.conditional && queryStore) {
            var conditionalTooltipHelper = new ksys_app_template_1.helpers.ConditionalHelper(tooltip.conditional);

            if (conditionalTooltipHelper.matchesWithOptions({
              executionOptions: queryStore.executionOptions
            })) {
              response = tooltip;
              break;
            }
          } else if (tooltip) {
            response = tooltip;
            break;
          }
        }
      }
    }

    return response;
  };

  Table.prototype.getTooltipRowProps = function (row, column) {
    var response;

    if (column && Array.isArray(column.tooltips) && column.tooltips.length > 0) {
      var tooltips = ksys_app_template_1.utils.collection.filterWithMatchingProperties(column.tooltips, {
        target: 'row'
      });

      if (tooltips) {
        for (var i = 0; i < tooltips.length; i++) {
          var tooltip = tooltips[i];

          if (tooltip && tooltip.conditional && tooltip.conditional) {
            var conditionalTooltipHelper = new ksys_app_template_1.helpers.ConditionalHelper(tooltip.conditional);

            if (conditionalTooltipHelper.matches(row)) {
              response = tooltip;
              break;
            }
          }
        }
      }
    }

    return response;
  };

  Table.prototype.getTooltip = function (element) {
    var target = element.target,
        conditional = element.conditional,
        tooltipProps = __rest(element, ["target", "conditional"]);

    return tooltipProps && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps));
  };

  Table.prototype.getEvents = function (eventsForElement, row, rowIndex, column, columnIndex, cellValue) {
    if (eventsForElement === void 0) {
      eventsForElement = {};
    }

    var response = {};
    var keys = Object.keys(eventsForElement);

    var _loop_1 = function _loop_1(key) {
      var handler = eventsForElement[key];

      response[key] = function (event) {
        return handler && handler(event, row, rowIndex, column, columnIndex, cellValue);
      };
    };

    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
      var key = keys_1[_i];

      _loop_1(key);
    }

    return response;
  };

  Table.prototype.isPanelOpen = function (heading, index) {
    var accordionProps = this.props.accordionProps;
    var openPanels = accordionProps && accordionProps.openPanels || [];
    return openPanels.indexOf(heading) >= 0 || openPanels.indexOf(index) >= 0;
  };

  Table.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.responsiveMode,
        responsiveMode = _b === void 0 ? 'renderTable' : _b;
    var disclaimersProps = this.getDisclaimersProps();
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
      _this.translationContext = translationContext;
      return react_1.default.createElement(react_1.Fragment, null, !responsiveMode && _this.renderTable(), responsiveMode && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(react_socks_1.default, {
        small: true,
        down: true
      }, responsiveMode === 'pivotToCard' && _this.renderCards(), responsiveMode === 'pivotToAccordion' && _this.renderAccordion(), responsiveMode === 'renderTable' && _this.renderTable()), react_1.default.createElement(react_socks_1.default, {
        medium: true,
        up: true
      }, _this.renderTable())), disclaimersProps && react_1.default.createElement(DisclaimersWrapper_1.default, null, react_1.default.createElement(Disclaimers_1.default, __assign({}, disclaimersProps))));
    }));
  };

  Table.defaultProps = {
    cellPadding: 0,
    cellSpacing: 0
  };

  Table.loadCellSuperscripts = function (appKey, columns, rows, queryStore) {
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
      var row = rows_1[_i];

      for (var _a = 0, columns_1 = columns; _a < columns_1.length; _a++) {
        var column = columns_1[_a];
        var columnDisclaimers = [];
        var allDisclaimers = column.disclaimers;
        var targettedDisclaimers = allDisclaimers && allDisclaimers.cell;

        if (targettedDisclaimers && queryStore) {
          ksys_app_template_1.utils.globalDisclaimers.initializeGlobalDisclaimers();
          var globalDisclaimerStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();

          if (globalDisclaimerStore) {
            for (var _b = 0, targettedDisclaimers_1 = targettedDisclaimers; _b < targettedDisclaimers_1.length; _b++) {
              var targettedDisclaimer = targettedDisclaimers_1[_b];
              var disclaimers = targettedDisclaimer.disclaimers,
                  conditional = targettedDisclaimer.conditional;

              if (conditional) {
                var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional);

                if (conditionalHelper.matchesWithOptions({
                  instance: row,
                  executionOptions: {
                    responseContext: row
                  }
                })) {
                  columnDisclaimers.push.apply(columnDisclaimers, globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, row, queryStore], disclaimers)));
                }
              } else {
                columnDisclaimers.push.apply(columnDisclaimers, globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, row, queryStore], disclaimers)));
              }
            }
          }
        }

        if (columnDisclaimers && columnDisclaimers.length > 0) {
          var id = column.id;

          if (!row._superscriptsByColumnId) {
            row._superscriptsByColumnId = {};
          }

          row._superscriptsByColumnId[id] = columnDisclaimers.map(function (columnDisclaimer) {
            return columnDisclaimer.superscript;
          }).sort();
        }
      }
    }
  };

  __decorate([mobx_1.computed], Table.prototype, "sort", null);

  __decorate([mobx_1.observable.ref], Table.prototype, "sortingDirections", void 0);

  __decorate([mobx_1.observable.ref], Table.prototype, "grouping", void 0);

  __decorate([mobx_1.computed], Table.prototype, "hasGrouping", null);

  __decorate([mobx_1.observable.ref], Table.prototype, "rows", void 0);

  __decorate([mobx_1.computed], Table.prototype, "emptyColumnIds", null);

  __decorate([mobx_1.computed], Table.prototype, "columns", null);

  __decorate([mobx_1.computed], Table.prototype, "headerColumns", null);

  __decorate([mobx_1.computed], Table.prototype, "events", null);

  Table = __decorate([mobx_react_1.observer], Table);
  return Table;
}(shared_1.ComponentBase);

exports.Table = Table;
exports.default = shared_1.InjectedStyledComponent(Table, Table_meta_1.TABLE_CATEGORY_KEY, Table_meta_1.TABLE_COMPONENT_KEY);